import { useEffect, useRef, useState } from "react";
import { fetchGetFile, fetchGetFolder, fetchGetVideo, fetchUpdateUserVideoStatistics, markLearningPathStepAsCompleted } from "./FolderApi";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import { setLoading } from "../../services/global/globalSlice";
import { selectCurrentLang, selectTranslations } from "../../services/i18n/i18nSlice";

// Import the main component
import { LocalizationMap, Viewer } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';


import it_IT from '@react-pdf-viewer/locales/lib/it_IT.json';

// Import the styles
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';

import FolderTopBar from "./_components/FolderTopBar";
import { API_URL } from "../../config/constants";
import FolderCompletedModal from "./_components/FolderCompletedModal";
import { useFileUrl } from "../../api/nativeFiles";


export default function ContentViewer() {

    const [folderData, setFolderData] = useState(null)
    const [learningPathModalData, setLearningPathModalData] = useState({
        show: false, destination_folder_id: null
    })
    const dispatch = useDispatch()

    const defaultLayout = defaultLayoutPlugin({
        renderToolbar: (Toolbar) => (
            <Toolbar>{renderDefaultToolbar(transform)}</Toolbar>
        ),
    });

    const { renderDefaultToolbar } = defaultLayout.toolbarPluginInstance;

    const transform = (slot) => ({
        ...slot,
        Open: () => <></>,
        OpenMenuItem: () => <></>,
        Download: () => <></>,
        DownloadMenuItem: () => <></>,
        Print: () => <></>,
        PrintMenuItem: () => <></>,
    });


    const location = useLocation()
    const {file_id, folder_id} = useParams()

    const t = useSelector(selectTranslations)


    const lang = useSelector(selectCurrentLang)
    const loadFolderData = async () => {
        const response = await fetchGetFolder({...(folder_id && {folder_id: folder_id})})
        if (response.success){
            setFolderData(response.data)
            dispatch(setLoading(false))
        } else {
            toast.error(t.training.error_loading_folder)
            dispatch(setLoading(false))
        }
    }

    const loadFileData = async () => {
        const response = await fetchGetFile({...(file_id && {file_id: file_id})})
        if (response.success){
            console.log(response.data)
            dispatch(setLoading(false))
        } else {
            toast.error(t.training.error_loading_folder)
            dispatch(setLoading(false))
        }
    }

    const handleEndDocument = async (p) => {
        console.log("Document ended", folderData, p.currentPage);
        if(folderData && folderData?.parent_folder_details?.type === 'learning_path'){
            if(p.currentPage >= p.doc?._pdfInfo?.numPages - 3){
                let response = await markLearningPathStepAsCompleted(
                    {
                        folder_id: folderData?.folder_id, 
                        parent_folder_id: folderData?.parent_folder_id
                    }
                )
                if(response.success){
                    setLearningPathModalData({
                        destination_folder_id: response.data?.next_learning_path_subfolder_id !== folderData?.folder_id ? response.data?.next_learning_path_subfolder_id : folderData?.folder_id,
                        show: true
                    })
                } else {
                    console.log("Error marking step as completed")      
                }
            }
        }
    }

    useEffect(()=>{
        if(location.state?.folderData)
            setFolderData(location.state?.folderData)
        else    
            loadFolderData()
    },[location])

    const fileUrl = useFileUrl(`${API_URL}/get_file?file_id=${file_id}`)

    return(
        <section className="content_section">
            {
                folderData ? <FolderTopBar current={true} folderData={folderData} t={t} /> : null
            }
            
            <div className="mt-5 mt-lg-4">
                {
                    !fileUrl ? null :
                    file_id && folderData?.files?.find(f => f.file_id === file_id)?.filetype === "pdf" ?
                    <div className="content_viewer">
                        <Viewer 
                            localization={lang === 'it' ? it_IT : undefined} 
                            fileUrl={fileUrl}
                            plugins={[
                                // Register plugins
                                defaultLayout
                            ]}
                            onPageChange={handleEndDocument}
                        />
                        
                    </div>
                    :
                        fileUrl && <iframe src={fileUrl} className="w-100" style={{height:'100%'}}/>
                }
            </div>
            <FolderCompletedModal folderData={folderData} nextFolderId={learningPathModalData?.destination_folder_id} show={learningPathModalData?.show || false} onClose={()=>setLearningPathModalData({show: false, destination_folder_id: null})} />
        </section>
    )
}